import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncatelines',
  standalone: false,
})
export class TruncateLinesPipe implements PipeTransform {
  //Takes a single string in, evaluates it for newline char and adds elispe to each newline at the set length
  //then outputs the updated newlines as a single string
  //useage, add this after param -> "{paramName} | truncatelines:{number}:{boolean}"
  transform(value: string, n: number, addElispe: boolean = false): string {
    let splitArray = value.split('\n'); //use the newline char to split
    let newString = '';
    if (splitArray) {
      splitArray.forEach((e, i) => {
        let truncVal: string;
        if (e.length <= n) truncVal = e;
        else {
          truncVal = e.substring(0, n);
          if (addElispe) truncVal += '...';
        }
        if (truncVal.length > 0) {
          newString += truncVal + '\n';
        }
      });
    }
    return newString;
  }
}
